import React, { Component } from "react";
import {
  Row,
  Col,
  Modal,
  ModalBody,
  ModalHeader,
  Button,
  Card,
  Form,
  FormGroup,
  Label,
  Input,
} from "reactstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
export default class CompleteTipModel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataLoading: false,
    };
    this.fileInput = React.createRef();
  }
  fileUploadTrigger = () => {
    this.fileInput.current.click();
  };
  render() {
    return (
      <div>
        <Modal
          isOpen={this.props.isOpen}
          toggle={this.props.toggleModel}
          size="lg"
          centered
          className="CreateTripModal"
          style={{ maxWidth: "48%" }}
        >
          <ModalHeader>
            <div className="Heading">
              <h4 className="fontRoboto light__span"> Complete Trip</h4>
              <svg
                onClick={() => this.props.toggleModel()}
                width="15"
                height="15"
                viewBox="0 0 15 15"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M13.9092 1.82141L1.90918 13.8214"
                  stroke="#2800FC"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M1.90918 1.82141L13.9092 13.8214"
                  stroke="#2800FC"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
          </ModalHeader>

          <ModalBody>
            <Card className="p-1 darkBackgroundList">
              <div>
                <>
                  <Row className="mt-2">
                    <Col md="12">
                      <FormGroup>
                        <Label
                          htmlFor="example-text-input"
                          className="fontRoboto154 mb-2 light__span"
                        >
                          Clousure Date
                        </Label>
                        <DatePicker
                          selected={this.props.tripCompletedDate}
                          className="form-control mt-2"
                          maxDate={new Date()}
                          showTimeInput
                          timeInputLabel="Time:"
                          dateFormat="dd/MM/yyyy h:mm aa"
                          onChange={(e) => {
                            this.props.onChangeInput("tripCompletedDate", e);
                          }}
                          placeholderText="Select a clousure date"
                          
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row className="mt-2">
                    <Col md="12">
                      <FormGroup>
                        <Label
                          htmlFor="example-text-input"
                          className="fontRoboto154 mb-2 light__span"
                        >
                          Remarks
                        </Label>
                        <Input
                          name="remark"
                          placeholder="Remark"
                          type="text"
                          value={this.props.remark}
                          className="form-control-lg"
                          id="exampleFormControlInput1"
                          onChange={(e) =>
                            this.props.onChangeInput("remark", e.target.value)
                          }
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row className="mt-2">
                    <Col md="12">
                      <FormGroup>
                        <Label
                          htmlFor="example-text-input"
                          className="fontRoboto154 mb-2 light__span"
                        >
                          Proof
                        </Label>
                        <div className="imageDiv darkInputHighlightDiv">
                          <div className="d-block">
                            <svg
                              onClick={() => this.fileUploadTrigger()}
                              width="150"
                              height="150"
                              viewBox="0 0 50 50"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M0 31.6534C0.0758962 31.2107 0.126494 30.768 0.227689 30.3253C0.809559 27.6309 2.23894 25.5185 4.51582 23.9753C4.65497 23.8741 4.80676 23.7729 4.9712 23.659C4.17429 20.9521 4.57907 18.4855 6.60297 16.4616C8.61422 14.4503 11.0808 13.9949 13.7372 14.8045C17.0893 8.92253 22.0225 6.15232 28.7773 7.22752C33.9256 8.04973 39.1245 12.4517 39.9214 19.3709C40.2376 19.4468 40.5665 19.4974 40.8827 19.5986C44.8167 20.7876 47.511 23.3428 48.8265 27.2009C50.6607 32.5515 48.7633 37.9781 44.0704 41.1531C42.2995 42.3548 40.3262 42.9873 38.1631 42.9873C35.0008 42.9873 31.8511 42.9873 28.6888 42.9873C28.499 42.9873 28.3093 42.9873 28.0942 42.9873C28.0942 39.3949 28.0942 35.8657 28.0942 32.2733C28.2587 32.2606 28.4105 32.248 28.5623 32.248C29.4351 32.248 30.3079 32.2353 31.168 32.248C31.7246 32.2606 32.2432 32.2227 32.5342 31.6534C32.8378 31.0842 32.5595 30.6415 32.2306 30.1988C31.0415 28.5543 29.8525 26.9099 28.6635 25.2655C27.7021 23.9373 26.7408 22.5965 25.7794 21.2683C25.1343 20.3829 24.35 20.3702 23.7176 21.2683C21.5419 24.2662 19.3788 27.2768 17.2031 30.2747C17.1525 30.3379 17.1146 30.4012 17.064 30.4771C16.811 30.8565 16.7351 31.2487 16.9501 31.6661C17.1652 32.0709 17.5194 32.2606 17.9874 32.2606C19.1132 32.2606 20.239 32.2606 21.4027 32.2606C21.4027 35.853 21.4027 39.3949 21.4027 42.9999C21.2003 42.9999 21.0106 42.9999 20.8209 42.9999C17.3043 42.9999 13.7878 42.9873 10.2839 42.9999C6.78006 43.0126 4.11104 41.4314 2.0745 38.6865C0.974001 37.1939 0.328883 35.5115 0.0885456 33.6647C0.0758962 33.5761 0.0252987 33.4876 0 33.3991C0 32.8172 0 32.2353 0 31.6534Z"
                                fill="#C6C6C6"
                              />
                            </svg>
                            <input
                              type="file"
                              name="Image"
                              multiple={false}
                              accept=".png,.jpg,.jpeg,.pdf"
                              style={{ display: "none" }}
                              ref={this.fileInput}
                              onChange={(e) => {
                                this.props.fileUpload(e);
                              }}
                            />
                            <div className="d-flex">
                              {this.props.selectedFile ? (
                                <div className="PreviewDivPart">
                                  <React.Fragment>
                                    <div className="ArryyIcon">
                                      {this.props.selectedFile?.type ===
                                      "application/pdf" ? (
                                        <span className="clickText">
                                          {this.props.selectedFile?.name
                                            ? this.props.selectedFile?.name
                                            : "Click here to upload File"}
                                        </span>
                                      ) : (
                                        <img
                                          src={URL.createObjectURL(
                                            this.props.selectedFile
                                          )}
                                          alt=""
                                          width={300}
                                          height={140}
                                        />
                                      )}
                                    </div>
                                  </React.Fragment>
                                </div>
                              ) : (
                                ""
                              )}
                            </div>
                          </div>
                        </div>
                      </FormGroup>
                    </Col>
                  </Row>

                  <Button
                    color="primary"
                    // type="submit"
                    className="mt-4"
                    onClick={this.props.handleSubmit}
                  >
                    Submit
                  </Button>
                  <Button
                    color="success"
                    // type="submit"
                    className="mt-4 ml-2"
                    onClick={() => this.props.resetCompleteTrip()}
                  >
                    Reset
                  </Button>
                  <Button
                    color="secondary"
                    // type="submit"
                    style={{float:"right"}}
                    className="mt-4 ml-4"
                    onClick={() => this.props.toggleModel()}
                  >
                    Cancel
                  </Button>
                </>
              </div>
            </Card>
          </ModalBody>
        </Modal>
      </div>
    );
  }
}
